<template>
  <div class="chart-wrap" :style="`height:${_height}`">
    <div v-if="visible" key="chart" ref="chart" class="chart-layout" />
    <slot v-else-if="!loading">
      <div class="empt-text">
        <span>暂无数据</span>
      </div>
    </slot>
  </div>
</template>

<script>
// import echarts from 'echarts';
import * as echarts from 'echarts';
import { getColors } from './constant.js';

export default {
  name: 'MyChart',
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    option: {
      type: [Object, Function],
      required: false,
      default: () => ({}),
    },
    height: {
      type: [String, Number],
      required: false,
      default: '100%',
    },
    /**
     * 为undefined的时候，表示不起用dataset
     */
    dataset: {
      type: [Object, Array],
      required: false,
      default: undefined,
    },
  },
  computed: {
    _height() {
      const height = this.height;
      return typeof height === 'number' ? height + 'px' : height;
    },
    visible() {
      if (this.loading) {
        return false;
      } else {
        if (this.dataset === undefined) {
          return !!this.option;
        } else {
          return !!this.dataset;
        }
      }
    },
  },
  watch: {
    option: {
      handler() {
        this.init();
      },
    },
    dataset: {
      handler() {
        this.init();
      },
    },
  },
  mounted() {
    this.init();
    window.addEventListener('resize', this.resize);
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.resize);
    });
  },
  methods: {
    resize() {
      this.myChart && this.myChart.resize();
    },
    init() {
      if (this.visible) {
        this.$nextTick(() => {
          const option =
            typeof this.option === 'function'
              ? this.option(this.dataset)
              : this.option;
          const { props, ...dataset } = this.dataset || {};
          this.myChart = echarts.init(this.$refs.chart);
          this.myChart.setOption({
            color: getColors(),
            ...option,
            ...dataset,
            ...props,
          });
        });
      }
    },
    getInstance() {
      return this.myChart;
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-wrap {
  .chart-layout {
    height: 100%;
    width: 100%;
  }
  .empt-text {
    height: 100%;
    width: 100%;
    position: relative;
    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 24px;
      color: #8c93a1;
    }
  }
}
</style>
